module.exports = __webpack_public_path__ + "static/media/SN.2e741c06.wav";